import gql from 'graphql-tag';

export const FACILITIES_LIST_QUERY = gql`
	query Facilities {
		facilities(first: 50) {
			nodes {
				facilityId
				name
			}
		}
	}
`;

export const BILLING_CYCLES_LIST_QUERY = gql`
	query BillingCycles {
		billingCycles {
			billingCycleId
			name
		}
	}
`;
